import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
`;

export const diseableBox = styled.div`
	position: absolute;
	min-width: 100%;
	min-height: 100%;
	max-width: 100%;
	max-height: 100%;
	z-index: 10;
	top: 0;
	left: 0;
	opacity: 0.5;
	cursor: not-allowed;
	background-color: ${color.interface.white};
`;

export const inputImg = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0.5rem;

	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}

	> input {
		display: none;
	}
`;

export const labelWithImage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	> label {
		min-height: 40px;
		max-height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: ${color.interface.lightGray};
		width: 100%;
		cursor: pointer;
		padding: 0.5rem 2rem 0.5rem 1rem;
		border-radius: 5px;
		border: 1px solid ${color.interface.lightGray2};
	}

	> svg {
		padding: 1rem;
		border: 1px solid ${color.interface.lightGray2};
		font-size: 40px;
		border-radius: 5px;
	}
`;

export const imageBall = styled.div`
	position: relative;
	width: 45px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.lightGray2};
	border-radius: 5px;

	> img {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}
`;

export const unselectImg = styled.div<{ $isShowBtnUnselect: boolean }>`
	position: absolute;
	cursor: pointer;
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShowBtnUnselect ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	background-color: rgba(52, 58, 64, 0.8);
	border-radius: 5px;

	> svg {
		font-size: 15px;
		color: ${color.interface.white};
	}
`;

export const seeImgBiggerProps = styled.div<{ $seeImgBigger: boolean }>`
	position: absolute;
	cursor: pointer;
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$seeImgBigger ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	background-color: rgba(52, 58, 64, 0.8);
	border-radius: 5px;

	> svg {
		font-size: 15px;
		color: ${color.interface.white};
	}
`;

export const blueBtn = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> label {
		all: unset;
		width: 100%;
		border-radius: 5px;
		text-align: center;
		cursor: pointer;
		font-size: 1.4rem;
		padding: 0.8rem;
		background-color: ${color.system.info};
		color: ${color.interface.white};
	}
`;

export const modalImg = styled.div`
	width: 100%;
	padding-top: 2rem;

	> img {
		width: 100%;
		max-height: 50vh;
		border-radius: 5px;
	}
`;
